import { LocalStorageKeys } from "@/constants/local-storage-keys";
import { atomWithStorage } from "jotai/utils";

export const developerModeAtom = atomWithStorage(LocalStorageKeys.DEVELOPER_MODE_KEY, false);
